export default {
  menu: {
    myOkr: '我的 OKR',
    leaders: '直属上级',
    subordinates: '直属下级',
    followings: '我的关注',
    team: '团队 OKR',
    departmentsSupported: '支持的团队',
    report: '统计分析',
    reportOverview: '概况分析',
    reportDepartment: '部门对比分析',
    myTeamOkrWeek: '我的团队周报',
    alignmentMap: '目标地图'
  },
  header: {
    customerServiceGroup: 'VIP 答疑群',
    backToOld: '返回旧版',
    searchPlaceholder: '请输入花名或姓名搜索查看他人的 OKR',
    vipGroupSrc: require('@/assets/images/vip-group-zh.png'),
    dropdownMenu: {
      okrConcept: {
        title: 'OKR 是什么',
        url: 'https://funplus.feishu.cn/wiki/NP5RwTp7siZIx9kn2wJckgFjnz3'
      },
      newFeatures: {
        title: '新功能介绍',
        url: 'https://funplus.feishu.cn/wiki/ZN3PwFijOinJePkYgMLctE6fnah'
      },
      manual: {
        title: '使用手册',
        url: 'https://funplus.feishu.cn/wiki/I4XtwjhqRiikgNkFie4cZ194n7g'
      }
    }
  }
}
